import { injectable } from 'inversify';
import { env } from '../utils';

type FeatureFlags<T extends string> = 'logger' | T;

@injectable()
export class FeatureFlagsService<T extends string> {
  #flags: Set<FeatureFlags<T>>;

  constructor() {
    const featureFlags = env.FEATURE_FLAGS;
    this.#flags = new Set<FeatureFlags<T>>(featureFlags.split(',') as FeatureFlags<T>[]);
  }

  has(name: FeatureFlags<T>) {
    return this.#flags.has(name);
  }
}
